import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
const CreateDealIndex = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.CREATE_DEAL}/${ROUTE_KEYS.CREATE_DEAL_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default CreateDealIndex;
